/* =====================================================
   AE·ORA Homepage JS — aeora-home.js
   Drop in: assets/aeora-home.js
   Deferred. Covers: carousel, scroll reveal, proof counters, nav scroll.
===================================================== */
(function(){

  /* ---- OFFSCREEN VIDEO LOADING ----
     Keep multi-megabyte decorative video out of the critical path. */
  document.querySelectorAll('video.ae-lazy-video[data-video-src]').forEach(function(vid){
    function loadVideo(){
      if(vid.dataset.loaded === 'true') return;
      vid.dataset.loaded = 'true';
      vid.src = vid.dataset.videoSrc;
      vid.removeAttribute('data-video-src');
      vid.load();
      var play = vid.play();
      if(play && typeof play.catch === 'function') play.catch(function(){});
    }
    if('IntersectionObserver' in window){
      var videoObserver = new IntersectionObserver(function(entries){
        if(!entries[0].isIntersecting) return;
        videoObserver.disconnect();
        loadVideo();
      }, { rootMargin: '200px 0px', threshold: 0.01 });
      videoObserver.observe(vid);
    } else {
      window.addEventListener('load', loadVideo, { once: true });
    }
  });

  /* ---- VIDEO PLACEHOLDER HIDE ---- */
  document.querySelectorAll('.hero-video,.pv-video').forEach(function(vid){
    var placeholder = vid.nextElementSibling;
    if(!placeholder) return;
    function hide(){ if(placeholder) placeholder.style.display='none'; }
    if(vid.readyState>=3){ hide(); } else { vid.addEventListener('canplay',hide,{once:true}); }
  });

  /* ---- NAV PILL SCROLL TIGHTEN ---- */
  var pill = document.querySelector('.nav-pill');
  if(pill){
    window.addEventListener('scroll',function(){
      pill.style.padding = window.scrollY>48 ? '0 60px' : '0 80px';
    },{passive:true});
  }

  /* ---- MOBILE CAROUSEL ---- */
  function initCarousel(trackId, dotsId, prevId, nextId){
    if(window.innerWidth > 540) return;
    var track = document.getElementById(trackId);
    var dotsContainer = document.getElementById(dotsId);
    var prevBtn = document.getElementById(prevId);
    var nextBtn = document.getElementById(nextId);
    if(!track || !dotsContainer) return;
    var items = Array.from(track.children);
    var count = items.length;
    if(count < 2) return;
    dotsContainer.innerHTML = '';
    for(var i=0;i<count;i++){
      var dot = document.createElement('button');
      dot.className = 'carousel-dot'+(i===0?' active':'');
      dot.setAttribute('aria-label','Go to item '+(i+1));
      dot.dataset.index = i;
      dotsContainer.appendChild(dot);
    }
    var dots = dotsContainer.querySelectorAll('.carousel-dot');
    function getActive(){ var w=items[0].getBoundingClientRect().width+14; return Math.round(track.scrollLeft/w); }
    function scrollTo(index){ var w=items[0].getBoundingClientRect().width+14; track.scrollTo({left:index*w,behavior:'smooth'}); }
    function updateState(){ var a=Math.min(getActive(),count-1); dots.forEach(function(d,i){ d.classList.toggle('active',i===a); }); if(prevBtn) prevBtn.disabled=a===0; if(nextBtn) nextBtn.disabled=a===count-1; }
    updateState();
    var ticking=false;
    track.addEventListener('scroll',function(){ if(ticking) return; ticking=true; requestAnimationFrame(function(){ updateState(); ticking=false; }); },{passive:true});
    dots.forEach(function(dot){ dot.addEventListener('click',function(){ scrollTo(parseInt(this.dataset.index)); }); });
    if(prevBtn) prevBtn.addEventListener('click',function(){ scrollTo(Math.max(getActive()-1,0)); });
    if(nextBtn) nextBtn.addEventListener('click',function(){ scrollTo(Math.min(getActive()+1,count-1)); });
  }

  window.addEventListener('load',function(){
    initCarousel('product-carousel','product-dots','product-prev','product-next');
    initCarousel('proof-carousel','proof-dots','proof-prev','proof-next');
    initCarousel('reviews-carousel','reviews-dots','reviews-prev','reviews-next');
    initCarousel('system-carousel','system-dots','system-prev','system-next');
  });

  /* ---- SCROLL REVEAL ---- */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!reduced){
    var rs = document.createElement('style');
    rs.textContent = [
      '.will-reveal{opacity:0;transform:translateY(28px);transition:opacity 800ms cubic-bezier(0.4,0,0.2,1),transform 800ms cubic-bezier(0.4,0,0.2,1)}',
      '.will-reveal.revealed{opacity:1;transform:translateY(0)}',
      '.reveal-left{opacity:0;transform:translateX(-32px);transition:opacity 900ms cubic-bezier(0.4,0,0.2,1),transform 900ms cubic-bezier(0.4,0,0.2,1)}',
      '.reveal-left.revealed{opacity:1;transform:translateX(0)}',
      '.reveal-right{opacity:0;transform:translateX(32px);transition:opacity 900ms cubic-bezier(0.4,0,0.2,1),transform 900ms cubic-bezier(0.4,0,0.2,1)}',
      '.reveal-right.revealed{opacity:1;transform:translateX(0)}',
      '.sd0{transition-delay:0ms!important}.sd1{transition-delay:100ms!important}.sd2{transition-delay:200ms!important}.sd3{transition-delay:300ms!important}.sd4{transition-delay:400ms!important}',
      '.hd0{transition-delay:0ms!important}.hd1{transition-delay:120ms!important}.hd2{transition-delay:240ms!important}.hd3{transition-delay:360ms!important}.hd4{transition-delay:480ms!important}.hd5{transition-delay:600ms!important}'
    ].join('');
    document.head.appendChild(rs);

    var heroEls=['.hero-eyebrow','.hero-h1','.hero-sub','.hero-btns','.hero-proof','.hero-visual'];
    heroEls.forEach(function(sel,i){ var el=document.querySelector(sel); if(el) el.classList.add('will-reveal','hd'+i); });
    ['.proof-card','.review-card','.prod-card','.system-card'].forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el,i){ el.classList.add('will-reveal','sd'+Math.min(i%4,4)); });
    });
    document.querySelectorAll('.section-header-centered,.proof-heading-wrap').forEach(function(el){ el.classList.add('will-reveal','sd0'); });
    var pvCard=document.querySelector('.pv-card'); var productInfo=document.querySelector('.product-info');
    if(pvCard) pvCard.classList.add('reveal-left');
    if(productInfo) productInfo.classList.add('reveal-right');
    var quizText=document.querySelector('.quiz-text'); var quizVisual=document.querySelector('.quiz-visual');
    if(quizText) quizText.classList.add('reveal-left');
    if(quizVisual) quizVisual.classList.add('reveal-right','sd1');
    ['.story-strip-inner','.email-inner'].forEach(function(sel){ document.querySelectorAll(sel).forEach(function(el,i){ el.classList.add('will-reveal','sd'+Math.min(i,4)); }); });
    document.querySelectorAll('.trust-item').forEach(function(el,i){ el.style.transitionDelay=(i*60)+'ms'; el.classList.add('will-reveal'); });

    function revealHero(){ heroEls.forEach(function(sel){ var el=document.querySelector(sel); if(el) el.classList.add('revealed'); }); }
    if(document.fonts&&document.fonts.ready){ document.fonts.ready.then(function(){ requestAnimationFrame(function(){ requestAnimationFrame(revealHero); }); }); }
    else { window.addEventListener('load',function(){ requestAnimationFrame(function(){ requestAnimationFrame(revealHero); }); }); }

    if('IntersectionObserver' in window){
      var observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){ if(entry.isIntersecting){ entry.target.classList.add('revealed'); observer.unobserve(entry.target); } });
      },{threshold:0,rootMargin:'0px 0px -80px 0px'});
      document.querySelectorAll('.will-reveal,.reveal-left,.reveal-right').forEach(function(el){ if(!el.classList.contains('revealed')) observer.observe(el); });
    }
  }

  /* ---- PROOF COUNTERS ---- */
  (function(){
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function easeOutExpo(t){ return t===1?1:1-Math.pow(2,-10*t); }
    function animateCount(el,target,suffix,duration){
      if(prefersReduced){ el.textContent=target+suffix; return; }
      var start=null;
      function step(ts){ if(!start) start=ts; var elapsed=ts-start; var p=Math.min(elapsed/duration,1); el.textContent=Math.round(easeOutExpo(p)*target)+suffix; if(p<1) requestAnimationFrame(step); else el.textContent=target+suffix; }
      requestAnimationFrame(step);
    }
    function animateWord(el,word){
      if(prefersReduced){ el.textContent=word; return; }
      el.innerHTML='';
      word.split('').forEach(function(ch){
        var s=document.createElement('span');
        s.style.cssText='display:inline-block;opacity:0;transition:opacity 400ms cubic-bezier(0.4,0,0.2,1)';
        s.textContent=ch===' '?'\u00a0':ch;
        el.appendChild(s);
      });
      el.querySelectorAll('span').forEach(function(s,i){ setTimeout(function(){ s.style.opacity='1'; },i*55); });
    }
    var proofSection=document.querySelector('.proof-section');
    if(!proofSection) return;
    var fired=false;
    var po=new IntersectionObserver(function(entries){
      if(fired) return;
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        fired=true; po.disconnect();
        setTimeout(function(){
          document.querySelectorAll('.proof-num').forEach(function(el){
            if(el.dataset.count!==undefined) animateCount(el,parseInt(el.dataset.count,10),el.dataset.suffix||'',2000);
            else if(el.dataset.word) animateWord(el,el.dataset.word);
          });
        },300);
      });
    },{threshold:0.3});
    po.observe(proofSection);
  })();

})();
